// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2owOY","option":"styles_option__13F_l","selected":"styles_selected__32P7s"};